import React, { Fragment, useEffect, useRef, useState } from "react";

const ForumSkeleton = ({ items = 5 }) => {
    return (
        <div role="status" className="flex flex-col mb-2 w-full animate-pulse bg-gray-100 mb-5">
            <div className="flex flex-row w-full p-2 gap-x-2 border-b border-gray-200 justify-start">
                <div className="flex h-16 w-16 min-w-16 bg-gray-200 rounded-sm dark:bg-gray-700 ">
                </div>
                <div className="flex flex-col  flex-1 align-start justify-start">
                    <div className="h-5 w-1/2 bg-gray-200 rounded-sm dark:bg-gray-700 ">
                    </div>
                    <div className="h-3 w-3/4 bg-gray-200 rounded-sm dark:bg-gray-700 mt-1 ">
                    </div>
                    <div className="h-3 w-3/4 bg-gray-200 rounded-sm dark:bg-gray-700 mt-1 ">
                    </div>
                    <div className="h-3 w-3/4 bg-gray-200 rounded-sm dark:bg-gray-700 mt-1 ">
                    </div>
                    <div className="flex flex-row gap-x-5">
                        <div className="h-2 w-40  bg-gray-200 rounded-sm dark:bg-gray-700 mt-5 ">
                        </div>
                        <div className="h-2 w-40  bg-gray-200 rounded-sm dark:bg-gray-700 mt-5 ">
                        </div>
                        <div className="h-2 w-40  bg-gray-200 rounded-sm dark:bg-gray-700 mt-5 ">
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-row justify-between items-center w-full p-2 gap-x-2 border-b border-gray-200 justify-start">
                <div className="flex flex-row items-center gap-x-2">
                    <div className="flex h-4 w-4 min-w-16 bg-gray-200 rounded-sm dark:bg-gray-700 ">
                    </div>
                    <div className="flex h-5 w-10 min-w-16 bg-gray-200 rounded-sm dark:bg-gray-700 ">
                    </div>
                </div>
                <div className="flex h-8 w-40 min-w-16 bg-gray-200 rounded-sm dark:bg-gray-700 ">
                </div>
            </div>
            {[...Array(items)].map((e, i) => (
                <div key={i} className="flex flex-row w-full p-2 gap-x-2 border-b border-gray-200 justify-start">
                    <div className="flex h-16 w-16 min-w-16 bg-gray-200 rounded-sm dark:bg-gray-700 ">
                    </div>
                    <div className="flex flex-col  flex-1 align-start justify-start">
                        <div className="h-4 w-48 bg-gray-200 rounded-sm dark:bg-gray-700 ">
                        </div>
                        <div className="h-2 w-3/4 bg-gray-200 rounded-sm dark:bg-gray-700 mt-1 ">
                        </div>
                        <div className="flex flex-row gap-x-5">
                            <div className="h-2 w-20  bg-gray-200 rounded-sm dark:bg-gray-700 mt-5 ">
                            </div>
                            <div className="h-2 w-20  bg-gray-200 rounded-sm dark:bg-gray-700 mt-5 ">
                            </div>
                            <div className="h-2 w-20  bg-gray-200 rounded-sm dark:bg-gray-700 mt-5 ">
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            <span className="sr-only">Loading...</span>
        </div>
    )
}

export default ForumSkeleton;

